import { Link } from 'react-router-dom';
import Container from './Container';

import logo from '../../img/costs_logo.png';
import styles from './styles/Navbar.module.css';

export default function Navbar() {
    return (
        <nav className={styles.navbar}>
            <Container>
                <Link to={'/'}>
                    <img src={logo} alt='Costs' />
                </Link>
                <ul className={styles.list}>
                    <li className={styles.item}>
                        <Link to={'/'}>Home</Link>
                    </li>
                    <li className={styles.item}>
                        <Link to={'/contact'}>Contact</Link>
                    </li>
                    <li className={styles.item}>
                        <Link to={'/company'}>Company</Link>
                    </li>
                    <li className={styles.item}>
                        <Link to={'/projects'}>Projects</Link>
                    </li>
                </ul>
            </Container>
        </nav>
    )
}